import { render, staticRenderFns } from "./AppVideo.vue?vue&type=template&id=cb21933e&"
import script from "./AppVideo.vue?vue&type=script&lang=js&"
export * from "./AppVideo.vue?vue&type=script&lang=js&"
import style0 from "./AppVideo.vue?vue&type=style&index=0&id=cb21933e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports